import React from 'react'
import {useCentralServices} from './useCentralServices'
import {ClientModel} from '../../../central/model'
import {selectMapperByKeys} from '../../mappers/util'

export const useClients = () => {
  const [loading, setLoading] = React.useState(false)
  const [clients, setClients] = React.useState<{value: string; label: string}[]>([])
  const {getClients} = useCentralServices()

  const getClientsFn = async (filters: ClientModel, page: number) => {
    try {
      setLoading(true)
      const clients = await getClients(filters, page)
      const mappedClients = selectMapperByKeys(clients, 'id', 'nombre')
      const filteredData = mappedClients.filter((item) => item.value !== '4EsB2NAAsDA=')
      setClients(filteredData)
    } catch (error) {
      console.error('Error fetching clients:', error)
    } finally {
      setLoading(false)
    }
  }

  const clearClients = () => {
    setClients([])
  }

  return {
    loading,
    clients,
    getClients: getClientsFn,
    clearClients,
  }
}
